export default __webpack_public_path__ + "static/48-17510a6704d796756e6e04c3b3490d45.gif";